<template>
    <div class="third-sdk-contain">
        <div>
            <p style="margin-top:0pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
                <span style="font-family:'微软雅黑'; font-weight:bold">
                    一部手机管旅游隐私政策摘要
                </span>
            </p>
            <p
                style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
                <span style="font-family:'微软雅黑'">
                    更新日期：2026年4月24日
                </span>
            </p>
            <p
                style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
                <span style="font-family:'微软雅黑'">
                    生效日期：2026年4月30日
                </span>
            </p>
            <p
                style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
                <span style="font-family:'Times New Roman'">
                    &#xa0;
                </span>
            </p>
            <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
                <span style="font-family:'微软雅黑'; font-weight:bold">
                    一、平台基本信息
                </span>
            </p>
            <p
                style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
                <span style="font-family:'微软雅黑'">
                    本平台由云南腾云信息产业有限公司（注册地：云南省昆明市西山区环城南路777号昆钢科技大厦 6F）提供，面向旅游行业监管工作人员及涉旅企业人员，提供投诉处置、退货办理、诚信评价、旅行社与导游管理、团队监管等服务。
                </span>
            </p>
            <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
                <span style="font-family:'微软雅黑'; font-weight:bold">
                    二、我们如何收集和使用您的信息
                </span>
            </p>
            <p
                style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
                <span style="font-family:'Times New Roman'; font-weight:bold">
                    1.成为用户时收集的信息
                </span>
            </p>
            <p
                style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
                <span style="font-family:'微软雅黑'">
                    1.1管理部门用户：姓名、手机号码、身份证号（可选）。
                </span>
            </p>
            <p
                style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
                <span style="font-family:'微软雅黑'">
                    1.2旅行社用户：姓名、手机号码、旅行社相关资质信息。
                </span>
            </p>
            <p
                style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
                <span style="font-family:'微软雅黑'">
                    1.3导游用户：姓名、手机号码、导游证号、身份证号、导游执业相关信息。
                </span>
            </p>
            <p
                style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
                <span style="font-family:'微软雅黑'">
                    以上信息均为您主动提供。
                </span>
            </p>
            <p
                style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
                <span style="font-family:'微软雅黑'; font-weight:bold">
                    2.基础服务收集的信息
                </span>
            </p>
            <p
                style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
                <span style="font-family:'微软雅黑'">
                    2.1投诉管理
                </span>
            </p>
            <p
                style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
                <span style="font-family:'微软雅黑'">
                    您主动提供的信息：
                </span>
                <span style="font-family:'微软雅黑'; font-weight:bold">
                    游客的姓名、手机号
                </span>
                <span style="font-family:'微软雅黑'">
                    、
                </span>
                <span style="font-family:'微软雅黑'; font-weight:bold">
                    游客身份证号。
                </span>
            </p>
            <p
                style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
                <span style="font-family:'微软雅黑'">
                    我们收集的信息：
                </span>
                <span style="font-family:'微软雅黑'; font-weight:bold">
                    浏览记录、软件使用记录、点击记录、收藏列表在内的服务日志信息
                </span>
                <span style="font-family:'微软雅黑'">
                    。
                </span>
            </p>
            <p
                style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
                <span style="font-family:'微软雅黑'">
                    2.2退货管理
                </span>
            </p>
            <p
                style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
                <span style="font-family:'微软雅黑'">
                    您主动提供的信息：
                </span>
                <span style="font-family:'微软雅黑'; font-weight:bold">
                    游客的姓名、手机号、游客身份证号、
                </span>
                <span style="font-family:'微软雅黑'; font-weight:bold">
                    游客手机号
                </span>
                <span style="font-family:'微软雅黑'; font-weight:bold">
                    短信验证码
                </span>
                <span style="font-family:'微软雅黑'; font-weight:bold">
                    。
                </span>
            </p>
            <p
                style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
                <span style="font-family:'微软雅黑'">
                    我们收集的信息：
                </span>
                <span style="font-family:'微软雅黑'; font-weight:bold">
                    浏览记录、软件使用记录、点击记录、收藏列表在内的服务日志信息
                </span>
                <span style="font-family:'微软雅黑'">
                    。
                </span>
            </p>
            <p
                style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
                <span style="font-family:'微软雅黑'">
                    2.3诚信评价管理
                </span>
            </p>
            <p
                style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
                <span style="font-family:'微软雅黑'">
                    我们收集的信息：
                </span>
                <span style="font-family:'微软雅黑'; font-weight:bold">
                    浏览记录、软件使用记录、点击记录、收藏列表在内的服务日志信息
                </span>
                <span style="font-family:'微软雅黑'">
                    。
                </span>
            </p>
            <p
                style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
                <span style="font-family:'微软雅黑'">
                    2.4旅行社管理
                </span>
            </p>
            <p
                style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
                <span style="font-family:'微软雅黑'">
                    我们收集的信息：
                </span>
                <span style="font-family:'微软雅黑'; font-weight:bold">
                    浏览记录、软件使用记录、点击记录、收藏列表在内的服务日志信息
                </span>
                <span style="font-family:'微软雅黑'">
                    。
                </span>
            </p>
            <p
                style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
                <span style="font-family:'微软雅黑'">
                    2.5导游管理
                </span>
            </p>
            <p
                style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
                <span style="font-family:'微软雅黑'">
                    我们收集的信息：
                </span>
                <span style="font-family:'微软雅黑'; font-weight:bold">
                    浏览记录、软件使用记录、点击记录、收藏列表在内的服务日志信息
                </span>
                <span style="font-family:'微软雅黑'">
                    。
                </span>
            </p>
            <p
                style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
                <span style="font-family:'微软雅黑'">
                    2.6团队监管
                </span>
            </p>
            <p
                style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
                <span style="font-family:'微软雅黑'">
                    我们收集的信息：
                </span>
                <span style="font-family:'微软雅黑'; font-weight:bold">
                    位置信息
                </span>
                <span style="font-family:'微软雅黑'">
                    、
                </span>
                <span style="font-family:'微软雅黑'; font-weight:bold">
                    设备信息、
                </span>
                <span style="font-family:'微软雅黑'; font-weight:bold">
                    浏览记录、软件使用记录、点击记录、收藏列表在内的服务日志信息
                </span>
                <span style="font-family:'微软雅黑'">
                    。
                </span>
            </p>
            <p
                style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
                <span style="font-family:'微软雅黑'">
                    2.7景区预约查询
                </span>
            </p>
            <p
                style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
                <span style="font-family:'微软雅黑'">
                    我们收集的信息：
                </span>
                <span style="font-family:'微软雅黑'; font-weight:bold">
                    浏览记录、软件使用记录、点击记录、收藏列表在内的服务日志信息
                </span>
                <span style="font-family:'微软雅黑'">
                    。
                </span>
            </p>
            <p
                style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
                <span style="font-family:'微软雅黑'">
                    2.8文旅项目管理
                </span>
            </p>
            <p
                style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
                <span style="font-family:'微软雅黑'">
                    我们收集的信息：
                </span>
                <span style="font-family:'微软雅黑'; font-weight:bold">
                    浏览记录、软件使用记录、点击记录、收藏列表在内的服务日志信息
                </span>
                <span style="font-family:'微软雅黑'">
                    。
                </span>
            </p>
            <p
                style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
                <span style="font-family:'微软雅黑'">
                    2.9考核管理
                </span>
            </p>
            <p
                style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
                <span style="font-family:'微软雅黑'">
                    我们收集的信息：
                </span>
                <span style="font-family:'微软雅黑'; font-weight:bold">
                    浏览记录、软件使用记录、点击记录、收藏列表在内的服务日志信息
                </span>
                <span style="font-family:'微软雅黑'">
                    。
                </span>
            </p>
            <p
                style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
                <span style="font-family:'微软雅黑'">
                    2.10账号管理
                </span>
            </p>
            <p
                style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
                <span style="font-family:'微软雅黑'">
                    您主动提供的信息：
                </span>
                <span style="font-family:'微软雅黑'; font-weight:bold">
                    手机号、密码、验证码、原绑定手机号的短信验证码、换绑手机号、换绑手机号的短信验证码、新密码。
                </span>
            </p>
            <p
                style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
                <span style="font-family:'微软雅黑'; font-weight:bold">
                    3.剪切板
                </span>
            </p>
            <p
                style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
                <span style="font-family:'微软雅黑'">
                    您使用复制粘贴功能时，我们会将内容临时写入剪贴板以实现快捷操作。我们不会留存剪贴板中的任何内容，也不会未经您授权擅自使用。
                </span>
            </p>
            <p
                style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
                <span style="font-family:'微软雅黑'; font-weight:bold">
                    4.消息通知
                </span>
            </p>
            <p
                style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
                <span style="font-family:'微软雅黑'">
                    我们使用消息推送SDK为您提供通知功能，必要时App会自启动以接收消息；您可通过手机设置关闭消息通知来阻止App自启动及推送。
                </span>
            </p>
            <p
                style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
                <span style="font-family:'微软雅黑'; font-weight:bold">
                    5.个性化推荐
                </span>
            </p>
            <p style="margin-top:3pt; margin-bottom:3pt; line-height:150%; font-size:12pt">
                <span style="font-family:'微软雅黑'">
                    在您使用一部手机管旅游平台的过程中，我们不会应用您的个人信息对您提供个性化推荐服务。
                </span>
            </p>
            <p
                style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
                <span style="font-family:'微软雅黑'; font-weight:bold">
                    6.安全保障
                </span>
            </p>
            <p
                style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
                <span style="font-family:'微软雅黑'">
                    为保障账号与系统安全、提升服务的可靠性与稳定性，我们会收集您的
                </span>
                <span style="font-family:'微软雅黑'; font-weight:bold">
                    个人常用设备信息、唯一设备识别码、登录IP地址、包括您授权的GPS位置以及WLAN
                </span>
                <span style="font-family:'微软雅黑'; font-weight:bold">
                    接入点和基站的传感器信息）、手机状态，以及个人信息：姓名、手机号、密码
                </span>
                <span style="font-family:'微软雅黑'">
                    ，用于身份验证、风险识别、安全事件防范及服务优化。在您激活使用时，我们还会通过腾讯TBS浏览服务收集相关
                </span>
                <span style="font-family:'微软雅黑'; font-weight:bold">
                    设备与网络信息
                </span>
                <span style="font-family:'微软雅黑'">
                    以支持页面浏览。
                </span>
            </p>
            <p
                style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
                <span style="font-family:'微软雅黑'; font-weight:bold">
                    7.设备调用服务
                </span>
            </p>
            <p
                style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
                <span style="font-family:'微软雅黑'; font-weight:bold">
                    位置权限：
                </span>
                <span style="font-family:'微软雅黑'">
                    购物店标记功能
                </span>
            </p>
            <p
                style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
                <span style="font-family:'微软雅黑'; font-weight:bold">
                    相机权限：
                </span>
                <span style="font-family:'微软雅黑'">
                    拍照、扫码、上传图片
                </span>
            </p>
            <p
                style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
                <span style="font-family:'微软雅黑'; font-weight:bold">
                    存储权限：
                </span>
                <span style="font-family:'微软雅黑'">
                    上传/保存图片、文件
                </span>
            </p>
            <p
                style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
                <span style="font-family:'微软雅黑'; font-weight:bold">
                    麦克风权限：
                </span>
                <span style="font-family:'微软雅黑'">
                    发送语音信息
                </span>
            </p>
            <p
                style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
                <span style="font-family:'微软雅黑'; font-weight:bold">
                    电话状态权限：
                </span>
                <span style="font-family:'微软雅黑'">
                    读取设备信息，保障账号安全
                </span>
            </p>
            <p
                style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
                <span style="font-family:'微软雅黑'">
                    权限仅在您使用时询问，可随时在设备设置中关闭。
                </span>
            </p>
            <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
                <span style="font-family:'微软雅黑'; font-weight:bold">
                    三、我们如何共享您的信息
                </span>
            </p>
            <p
                style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
                <span style="font-family:'Times New Roman'">
                    1.我们不主动共享您的个人信息至第三方，法律法规规定或经您明确同意的除外。
                </span>
            </p>
            <p
                style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
                <span style="font-family:'微软雅黑'">
                    2.部分服务通过第三方SDK实现，具体详见《一部手机管旅游App第三方信息共享清单》。
                </span>
            </p>
            <p
                style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
                <span style="font-family:'微软雅黑'">
                    3.您可通过“我的 - 设置 - 隐私说明”路径查看：个人信息收集清单、第三方信息共享清单。
                </span>
            </p>
            <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
                <span style="font-family:'微软雅黑'; font-weight:bold">
                    四、我们如何保护您的信息
                </span>
            </p>
            <p
                style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
                <span style="font-family:'微软雅黑'">
                    1.采用SSL加密传输、HTTPS安全浏览等业界标准措施。
                </span>
            </p>
            <p
                style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
                <span style="font-family:'微软雅黑'">
                    2.重要信息系统已通过网络安全等级保护三级测评和ISO27001认证。
                </span>
            </p>
            <p
                style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
                <span style="font-family:'微软雅黑'">
                    3.仅在本政策目的所需期限内保留您的信息，超出期限后删除或匿名化处理。
                </span>
            </p>
            <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
                <span style="font-family:'微软雅黑'; font-weight:bold">
                    五、您如何管理您的信息
                </span>
            </p>
            <p
                style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
                <span style="font-family:'微软雅黑'">
                    1.查询、更正或补充信息
                </span>
                <br style="page-break-before:always; clear:both" />
            </p>
            <p
                style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
                <span style="font-family:'微软雅黑'">
                    方式：通过“我的”页面查询个人信息；通过“我的 - 设置 - 账号设置”更改手机号或登录密码。通过文末联系方式联系我们更正姓名、部门等不可自行修改的信息。
                </span>
            </p>
            <p
                style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
                <span style="font-family:'微软雅黑'">
                    2.删除信息
                </span>
            </p>
            <p
                style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
                <span style="font-family:'微软雅黑'">
                    方式：通过“我的”页面删除签名信息，通过文末联系方式联系我们删除其他个人信息。
                </span>
            </p>
            <p
                style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
                <span style="font-family:'微软雅黑'">
                    3.获取个人信息副本
                </span>
            </p>
            <p
                style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
                <span style="font-family:'微软雅黑'">
                    方式：通过文末联系方式联系我们获取个人信息副本。
                </span>
            </p>
            <p
                style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
                <span style="font-family:'微软雅黑'">
                    4.撤回权限授权
                </span>
            </p>
            <p
                style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
                <span style="font-family:'微软雅黑'">
                    方式：通过“我的 - 设置 - 系统权限管理”关闭设备功能。
                </span>
            </p>
            <p
                style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
                <span style="font-family:'微软雅黑'">
                    5.注销账户
                </span>
            </p>
            <p
                style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
                <span style="font-family:'微软雅黑'">
                    方式：通过“我的 - 设置 - 账号注销”注销账户。
                </span>
            </p>
            <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
                <span style="font-family:'微软雅黑'; font-weight:bold">
                    六、未成年人信息保护
                </span>
            </p>
            <p
                style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
                <span style="font-family:'微软雅黑'">
                    1.本平台不面向未成年人开放，不允许未成年人注册账户。
                </span>
            </p>
            <p
                style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
                <span style="font-family:'微软雅黑'">
                    2.我们不会主动收集儿童个人信息，如发现误操作提交将立即删除。
                </span>
            </p>
            <p
                style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
                <span style="font-family:'微软雅黑'">
                    3.监护人如发现儿童误提交信息，可通过文末联系方式联系我们处理。
                </span>
            </p>
            <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
                <span style="font-family:'微软雅黑'; font-weight:bold">
                    七、本政策如何更新
                </span>
            </p>
            <p
                style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
                <span style="font-family:'微软雅黑'">
                    1.本政策可能变更，重大变更将通过弹窗或公示方式通知您。
                </span>
            </p>
            <p
                style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
                <span style="font-family:'微软雅黑'">
                    2.旧版本存档可联系我们查阅。
                </span>
            </p>
            <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
                <span style="font-family:'微软雅黑'; font-weight:bold">
                    八、投诉与联系方式
                </span>
            </p>
            <p
                style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
                <span style="font-family:'微软雅黑'">
                    客服电话：0871-68011179（工作日9:00-18:00）
                </span>
            </p>
            <p
                style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
                <span style="font-family:'微软雅黑'">
                    客服邮箱：
                </span>
                <a href="mailto:service@yntengyun.com" style="text-decoration:none">
                    <span style="font-family:'微软雅黑'; color:#000000">
                        service@yntengyun.com
                    </span>
                </a>
            </p>
            <p
                style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
                <span style="font-family:'微软雅黑'">
                    邮寄地址：云南省昆明市西山区环城南路777号昆钢科技大厦6F
                </span>
            </p>
            <p
                style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
                <span style="font-family:'微软雅黑'">
                    个人信息保护专员邮箱：
                </span>
                <span style="font-family:'Times New Roman'">
                    kevinliu@yntengyun.com
                </span>
            </p>
            <p
                style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
                <span style="font-family:'微软雅黑'">
                    我们将在15个工作日内回复。如对我们的处理不满意，您可向网信部门、消费者保护协会投诉，或提起诉讼。
                </span>
            </p>
            <p
                style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
                <span style="font-family:'Times New Roman'">
                    &#xa0;
                </span>
            </p>
            <p
                style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
                <span style="font-family:'Times New Roman'">
                    &#xa0;
                </span>
            </p>
            <p
                style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
                <span style="font-family:'Times New Roman'">
                    &#xa0;
                </span>
            </p>
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    data() {
        return {
            list: [],
            authData: {}
        };
    },
    computed: {},
    watch: {},
    methods: {},
    mounted() {
        document.title = '隐私政策摘要'
    },

    created() { },
    beforeCreate() {
        document.title = '隐私政策摘要'
    }
};
</script>

<style scoped lang="less">
.third-sdk-contain {
    padding: 0 12px 20px;

    p {
        line-height: 1.5;
    }
}
</style>
